import { createStore } from 'redux'

function userReducer(state, action)
{
  switch (action.type)
  {
    case 'INIT':
      return {
        data: action.data,
      }
    default:
      return {}
  }
}

let userStore = createStore(userReducer)

export default userStore
